import { CONSTANTS } from 'utils';
import { IModuleRoute, AppRouteNamesList, RoleTypes } from 'models';
import { SettingsPathList } from 'modules/admin-panel/pages/settings/models';

const requiredRoles = [RoleTypes.PRIMARY_ADMIN, RoleTypes.ADMIN];

export const settingsRoutes: IModuleRoute = {
	path: `${CONSTANTS.moduleAdminPath}${SettingsPathList.settings}`,
	name: AppRouteNamesList.settings,
	nested: [
		{
			path: SettingsPathList.surveyTracking,
			name: AppRouteNamesList.surveyTracking,
		},
		{
			path: `${SettingsPathList.surveyTracking}${SettingsPathList.roundScheduling}`,
			name: AppRouteNamesList.roundScheduling,
			requiredRoles,
		},
	],
};
